module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.messages) ? _c('f7-list', {
    staticClass: "itemList",
    style: (_vm.itemListStyle),
    attrs: {
      "media-list": "",
      "id": "payments-item-received"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('li', {
      key: message.id,
      class: {
        messageSelected: message.id && message.id === _vm.actualMessageId
      },
      style: ({
        background: _vm.getSeenStatusBackground(message.isRead)
      })
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.seeDetails(message, true)
        }
      }
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('f7-icon', {
      staticClass: "list-icon",
      attrs: {
        "icon": _vm.getIcon(message)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%"
      }
    }, [_c('div', {
      style: ({
        fontWeight: _vm.getSeenStatusFontWeight(message.isRead)
      })
    }, [_vm._v("\n                    " + _vm._s(_vm.getMessageLabel(message)) + "\n                    "), (_vm.notEmpty(message.attachmentId)) ? _c('span', {
      staticClass: "paperclip"
    }, [_vm._v("\n                       "), _c('f7-icon', {
      attrs: {
        "fa": "paperclip"
      }
    })], 1) : (_vm.notEmpty(message.AttachmentsNumber)) ? _c('span', {
      staticClass: "paperclip"
    }, [_vm._v("\n                       "), _vm._l((message.AttachmentsNumber), function(id) {
      return _c('f7-icon', {
        key: id,
        attrs: {
          "fa": "paperclip"
        }
      })
    })], 2) : _vm._e()])]), _vm._v(" "), (_vm.serviceId === _vm.services.PAYMENTS) ? _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%",
        "padding-right": "5%"
      }
    }, [_c('div', {
      staticClass: "text-center",
      style: ({
        'font-weight': _vm.getSeenStatusFontWeight(message.isRead)
      })
    }, [_c('label', {
      staticClass: "text-center m-0",
      class: _vm.getDirectionClass(message),
      staticStyle: {
        "width": "47.5%",
        "margin-top": "5px !important"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.getDirectionSymbol(message)) + " " + _vm._s(_vm.getAmount(message)) + " €\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.serviceId === _vm.services.DIRECTPAYMENTS) ? _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%",
        "padding-right": "5%"
      }
    }, [_c('div', {
      staticClass: "text-center",
      style: ({
        'font-weight': _vm.getSeenStatusFontWeight(message.isRead)
      })
    }, [_c('label', {
      staticClass: "text-center m-0",
      class: [message.direction === '0' ? 'positif_amount' : 'negatif_amount']
    }, [_vm._v("\n                      " + _vm._s(message.direction === '0' ? '+' : '-') + " " + _vm._s(_vm.getAmount(message)) + " €\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.serviceId === _vm.services.DOCUMENTSERVICE) ? _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "20%",
        "min-width": "20%",
        "max-width": "20%"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.getDocumentInfo(message)) + "\n                ")]) : _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "20%",
        "min-width": "20%",
        "max-width": "20%"
      }
    }, [(message.TotalPayments) ? _c('div', [_vm._v("\n                    " + _vm._s(message.TotalPayments + ' paiements') + "\n                  ")]) : (message.direction === '0') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('common.from_label') + ': ' + _vm.getSenderName(message)) + "\n                  ")]) : _c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('common.to_label') + ': ' + _vm.getRecipientName(message)) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "25%",
        "min-width": "25%",
        "max-width": "25%"
      }
    }, [_c('div', {
      staticClass: "item-after"
    }, [_c('span', [_vm._v(_vm._s(_vm.datePresentationLabel) + " " + _vm._s(_vm._f("formatDate")(_vm.getDate(message))))])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "justify-content": "normal"
      }
    }, [(message.TotalPayments) ? _c('div', {
      staticClass: "item-subtitle showSmallScreenOnly smallScreenStatementDescription"
    }, [_vm._v("\n              " + _vm._s(message.TotalPayments + ' paiements') + "\n            ")]) : (message.direction === '0') ? _c('div', {
      staticClass: "item-subtitle showSmallScreenOnly smallScreenStatementDescription"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('common.from_label') + ': ' + _vm.getSenderName(message)) + "\n            ")]) : _c('div', {
      staticClass: "item-subtitle showSmallScreenOnly smallScreenStatementDescription"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('common.to_label') + ': ' + _vm.getRecipientName(message)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle showSmallScreenOnly",
      class: _vm.getDirectionClass(message),
      staticStyle: {
        "margin-left": "auto"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getDirectionSymbol(message)) + " " + _vm._s(_vm.getAmount(message)) + " €\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%"
      }
    }, [_c('span', {
      staticClass: "statusLabel"
    }, [_vm._v("\n                " + _vm._s(_vm.getStatusLabel(message)) + "\n              ")])]), _vm._v(" "), (_vm.showAmountCreditDebit(message)) ? _c('div', {
      staticClass: "text-center",
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%",
        "padding-right": "5%"
      }
    }, [_c('span', {
      staticClass: "positif_amount"
    }, [_vm._v("\n                " + _vm._s('+' + message.AmountCredit) + " €\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "negatif_amount"
    }, [_vm._v("\n                " + _vm._s('-' + message.AmountDebit) + " €\n              ")])]) : _c('div', {
      staticClass: "showLargeScreenOnly text-center",
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%",
        "padding-right": "5%"
      }
    }, [(_vm.serviceId === _vm.services.PAYMENTS) ? _c('span', {
      staticClass: "text-center statusLabel m-0"
    }, [_vm._v("\n                " + _vm._s(message.direction === '1' ? _vm.getBankAccountCreditor(message) : _vm.getBankAccountDebitor(message)) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "text-center statusLabel m-0"
    }, [_vm._v("\n                " + _vm._s(message.direction === '0' ? _vm.getBankAccountCreditor(message) : _vm.getBankAccountDebitor(message)) + "\n              ")])]), _vm._v(" "), (message.TotalPaymentsAction) ? _c('div', {
      staticStyle: {
        "width": "27.5%",
        "min-width": "27.5%",
        "max-width": "27.5%"
      }
    }, [_c('span', {
      staticClass: "statusLabel showLargeScreenOnly"
    }, [_vm._v("\n                " + _vm._s('dont ' + message.TotalPaymentsAction + ' à traiter') + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row showSmallScreenOnly"
    }, [(_vm.serviceId === _vm.services.DOCUMENTSERVICE) ? _c('div', {
      staticClass: "item-subtitle showSmallScreenOnly",
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getDocumentInfo(message)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row showSmallScreenOnly"
    }, [_c('div', {
      staticClass: "statusLabel"
    }, [_vm._v("\n              " + _vm._s(_vm.getStatusLabel(message)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [(message.reminder === '1') ? _c('f7-icon', {
      staticClass: "orangeFont",
      attrs: {
        "fa": "bell"
      }
    }) : _vm._e()], 1)])])])])])
  }), 0) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71c37c1e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c37c1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/TransactionsList.vue
// module id = 2398
// module chunks = 2